import { Fade } from "@mui/material";
import cn from "classnames";
import useTranslate from "../../hooks/useTranslate";
import { IBlockWithInfoProps } from "./BlockWithInfo.props";
import styles from "./BlockWithInfo.module.scss";

const BlockWithInfo = ({ title, withBackground = false }: IBlockWithInfoProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Fade in={true} timeout={500}>
			<div className={styles.info}>
				<div className={cn({ [styles.infoWithBackground]: withBackground })}>{translate(title)}</div>
			</div>
		</Fade>
	);
};

export default BlockWithInfo;
